export default "__VITE_ASSET__DGo45p10__"